import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import { addLog } from 'assets/components/feedback/Feedback';
import useForm from 'assets/components/form/hooks/Form';
import Icon from 'assets/components/icon/Icon';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import Modal from 'assets/components/page/templates/Modal';
import ThemeModalDefault from 'assets/components/page/templates/themes/Theme.Modal.Default';
import { getLocales } from 'assets/locales/Locale';
import { defaultInputDateTimeFormat } from 'assets/utils/data/Date';
import { HttpStatus } from 'config/Api.Config';
import claimSaveApi from 'models/claims/claim/save/Api.Claim.Save';
import { useClaimEdit } from '../../ClaimEdit.Hooks';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import TextInput from 'assets/components/inputs/text/TextInput';

const ClaimEditUpdate = () => {
  const { lang } = getLocales();
  const { claim, setClaimEditAction, reloadClaim } = useClaimEdit();
  const form = useForm<Api.Core.Claim.Save.IRequest>({
    default: {
      ...claim,
    },
    validation: (data, errors) => {
      if (!data.incidentLocalDate) errors.incidentLocalDate = lang.mustNotBeEmpty;
    },
    onSubmit: async (data) => {
      const res = await claimSaveApi({ ...data, odometerReading: data.odometerReading ? data.odometerReading : 0 });

      if (res.status === HttpStatus.ok) {
        addLog({ success: lang.saveSuccess });
        setClaimEditAction(undefined);
        reloadClaim();
      } else {
        addLog({ error: res.message });
      }
    },
  });

  return (
    <Modal
      subcomponents={ThemeModalDefault}
      header={lang.edit}
      onClose={() => {
        form.reload();
        setClaimEditAction(undefined);
      }}
      render={
        <FormWrapper>
          <DateInput
            name="incidentLocalDate"
            label={lang.incidentLocalDate}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={form.data?.incidentLocalDate}
            isLocal={true}
            onChange={form.update}
            icon={<Icon class="fas-calendar-alt" />}
            error={form.errors?.incidentLocalDate}
          />
          {!claim?.odometerReading && (
            <NumberInput
              name="odometerReading"
              label={lang.odometerReading}
              value={form.data?.odometerReading}
              onChange={form.update}
            />
          )}
          <TextInput
            name="workOrderNumber"
            label={lang.workOrderNumber}
            value={form.data?.workOrderNumber}
            onChange={form.update}
          />
        </FormWrapper>
      }
      footer={
        <Button
          onClick={form.submit}
          media={<Icon class="fas-save" />}
          render={lang.submit}
          active={!form.hasErrors && form.isUpdated}
          disabled={form.hasErrors || !form.isUpdated}
          isLoading={form.isSubmitted}
          class={ThemeButtonCircle}
          htmlElementProps={{ title: lang.submit }}
        />
      }
    />
  );
};

export default ClaimEditUpdate;
